export default class TicketComposantController {
	static $inject = ['$state', '$scope', '$stateParams', 'TicketsCommunicationService', 'TicketsService', 'notification', '$uibModal'];

	constructor($state, $scope, $stateParams, TicketsCommunicationService, TicketsService, notification, $uibModal) {
		this.$state = $state;
		this.$scope = $scope;
		this.$stateParams = $stateParams;
		this.TicketsCommunicationService = TicketsCommunicationService;
		this.TicketsService = TicketsService;
		this.notification = notification;
		this.$uibModal = $uibModal;
	}

	async $onInit() {
		if (this.onTicketLoaded) {
			// récupération des ticket immediatement (utile pour la dap)
			this.loadTickets();
		}
		this.unregister = this.$scope.$watch(
			() => this.isOpen,
			() => {
				if (this.isOpen && !this.tickets) {
					this.loadTickets();
				}
			},
			true
		);
	}

	$onDestroy() {
		this.unregister();
	}

	async loadTickets() {
		if (this.id) {
			this.startLoading();
			try {
				const data = await this.TicketsService.getTicketComposant(this.id, this.domaine);
				this.tickets = data.tickets;
				if (this.onTicketLoaded) {
					this.onTicketLoaded({ tickets: this.tickets });
				}
				this.poidsTotalEntree = data.poidsTotalEntree;
				this.poidsTotalSortie = data.poidsTotalSortie;
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			}
			this.stopLoading();
		}
	}

	async exporter() {
		try {
			this.startLoading();
			this.isLoadExport = true;
			const fileName = 'Liste_tickets';
			let resultat = undefined;
			try {
				resultat = await this.TicketsService.exportTicketComposants(this.id, this.domaine);
			} catch (ex) {
				//si on a des exception à afficher, le faire de cette manière à cause du format de retour de type fichier
				const msgException = String.fromCharCode.apply(null, new Uint8Array(ex.data));
				this.notification.error('TICKETS.' + msgException);
				return false;
			}
			if (resultat) {
				const data = resultat.data;
				let headers = resultat.headers;
				headers = headers();

				const contentType = headers['content-type'];

				const linkElement = document.createElement('a');
				try {
					const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
					const url = window.URL.createObjectURL(blob);
					linkElement.setAttribute('href', url);
					linkElement.setAttribute('download', fileName + '.xlsx');

					const clickEvent = new MouseEvent('click', {
						view: window,
						bubbles: true,
						cancelable: false
					});
					linkElement.dispatchEvent(clickEvent);
				} catch (ex) {
					console.log('🚀 ~ TicketComposantController ~ exporter ~ ex:', ex);
				}
				return true;
			}
		} catch (ex) {
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
			this.isLoadExport = false;
		}
	}

	openTicket(ticket) {
		this.$uibModal.open({
			template: '<ticket-detail modal-instance="$ctrl.uibModalInstance" ticket-from-pre-fa="$ctrl.ticketFromPreFa"></ticket-detail>',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					const $ctrl = this;
					$ctrl.uibModalInstance = $uibModalInstance;
					$ctrl.ticketFromPreFa = ticket;
				}
			],
			controllerAs: '$ctrl',
			size: 'xxl'
		});
		// .result.then(
		// 	async function (result) {
		// 		// console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
		// 		// console.info(result);
		// 		// if (result) {
		// 		// }
		// 	},
		// 	function (reason) {}
		// );
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	openNewWindow(routeName, params) {
		const url = this.$state.href(routeName, params);
		window.open('gestion.html' + url);
	}
}
